import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type UserCollectionGroupFragment = { id: string, name: string };


export type UserCollectionGroupFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const UserCollectionGroupFragmentDoc = /*#__PURE__*/ gql`
    fragment UserCollectionGroup on UserCollectionGroupType {
  id
  name
}
    `;